import React, { useEffect } from "react";
import { Check, X, Crown, Star, Zap, Shield } from "lucide-react";

const PurohitSubscription = ({ onClose, onUpgrade }) => {

  // Lock screen scroll
  useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => (document.body.style.overflow = "auto");
  }, []);

  const features = [
    "Unlimited Puja Bookings",
    "Verified Purohit Badge",
    "Festival Season Profile Boost",
    "Priority Listing in Search Results",
    "WhatsApp & Call Support",
    "Commission-Free Direct Payments",
  ];

  return (
   <div className="fixed inset-0 bg-black/40 backdrop-blur-lg z-[2000] flex justify-center items-center">

      {/* POPUP CARD */}
      <div
        className="relative bg-white w-[92%] max-w-[450px] rounded-3xl shadow-2xl 
                   flex flex-col max-h-[90vh] overflow-y-auto"
      >

        {/* Close Button */}
        <button
          onClick={onClose}
          className="absolute top-3 right-3 bg-white text-red-600 
                     w-9 h-9 rounded-full flex items-center justify-center 
                     shadow-md z-20"
        >
          <X size={18} />
        </button>

        {/* HEADER GRADIENT */}
        <div className="bg-gradient-to-br from-orange-500 via-orange-600 to-red-600 
                        text-center pt-10 pb-16 px-5 rounded-t-3xl">
          <div className="w-16 h-16 mx-auto bg-white/20 rounded-full flex justify-center items-center shadow-md">
            <Crown className="text-white" size={28} />
          </div>
          <h2 className="text-white font-bold text-xl mt-2">Premium Plan</h2>
          <p className="text-white/90 text-xs mt-1">
            Unlock complete visibility & boost bookings
          </p>
        </div>

        {/* PRICE CARD OVERLAP */}
        <div className="relative -mt-10 mx-auto w-[85%]">
          <div className="bg-white rounded-xl p-4 shadow-lg border border-orange-200 text-center">
            <p className="text-xs text-gray-600">Monthly Subscription</p>
            <span className="text-3xl font-extrabold text-orange-600">₹1499</span>
            <span className="text-xs text-gray-500">/month</span>
            <p className="text-[10px] text-gray-500 mt-1">
              +18% GST → Total ₹{(1499 * 1.18).toFixed(0)}
            </p>
          </div>
        </div>

        {/* FEATURES */}
        <div className="px-6 mt-6 space-y-2 pb-4">
          {features.map((item, i) => (
            <div key={i} className="flex items-center gap-2 p-2.5 bg-green-50 border border-green-200 rounded-lg text-xs">
              <Check className="text-green-600" size={14} /> {item}
            </div>
          ))}
        </div>

        {/* CTA BUTTON */}
        <button
          onClick={onUpgrade}
          className="mx-auto mb-5 w-[85%] bg-gradient-to-r from-orange-600 to-red-500 py-3 
                     rounded-full text-white text-sm font-bold shadow-lg"
        >
          UPGRADE NOW →
        </button>
      </div>
    </div>
  );
};

export default PurohitSubscription;
